/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:18
 * @LastEditTime: 2023-08-31 18:19:23
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\form\view.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from "react";
import { Input, Tooltip } from "@platform/base";
import { localeLang } from '@platform/api';
import Dnd from '../../libs/dnd';
import { match } from '../../libs/utils';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

/**
 * 左侧的属性面板
 */
class View extends Component {
    constructor(props) {
        super(props);
    }

    onSearch = (value, e) => {
        const { store, code } = this.props;
        const viewStore = store.getStore(['cache', code, 'view']) || {};
        const { data = [] } = viewStore;

        const nextData = data.map(item => {
            const { label } = item;
            // 是否是过滤的
            item.filtered = match(label, value);
            return item;
        });

        store.setStore(['cache', code, 'view', 'value'], value, false);
        store.setStore(['cache', code, 'view', 'data'], nextData, true);

        // TODO search
        // scrollIntoView 聚焦到首项
    }

    // 如果当前是信息组元素  目标位置也是信息组关联元素  不能放置拖拽
    onDragEnd = (finalData, dragItem) => {
        const { store, code: areaCode } = this.props;
        const { attrcode } = dragItem;

        let nextFieldSourceItem = [];
        let currentItem = null;
        const viewData = store.getStore(['cache', areaCode, 'view', 'data']) || [];
        // 把关联的信息组找到 统一移动下位置
        viewData.filter(item => {
            const { attrcode: currentCode, groupRelationCode } = item;

            // 关联当前字段的信息组元素
            if (groupRelationCode === attrcode) {
                nextFieldSourceItem.push(item);
                return false;
            }

            if (currentCode === attrcode) {
                currentItem = item;
                return false;
            } else {
                return true;
            }
        });

        // 找到在新数据中的位置
        if (nextFieldSourceItem.length) {
            const groupItems = store.getStore(['cache', areaCode, 'groupItems']) || {};
            // 把currentItem插入进去
            groupItems && Object.values(nextFieldSourceItem).find((item, index) => {
                const currentGroup = groupItems[item.groupInfoId];
                if (currentGroup && currentGroup.direction === 'after') {
                    // 插入关联元素
                    nextFieldSourceItem.splice(index, 0, currentItem);
                    return true;
                }

                // 查找到最后 说明只有before没有after
                if (index === nextFieldSourceItem.length - 1) {
                    // 插入关联元素
                    nextFieldSourceItem.splice(index, 0, currentItem);
                    return true;
                }
            });
            // 有关联信息组, 剔除信息组数据
            finalData = finalData.filter(item => {
                const { groupRelationCode } = item;
                if (groupRelationCode === attrcode) {
                    return false;
                }
                return true;
            });
            const spliceIndex = finalData.findIndex(item => item.attrcode === attrcode);
            spliceIndex !== -1 && finalData.splice(spliceIndex, 1, ...nextFieldSourceItem);
        }

        this.finalData = finalData;
    }

    // 拖拽停止
    onStop = (props, monitor, component) => {
        const { store, code: areaCode } = this.props;
        // TODO 设置数据
        this.finalData && store.setStore(['cache', areaCode, 'view', 'data'], this.finalData, true);
        this.finalData = null;
    }

    // 分组名称变化
    onGroupTitleChange = (value, groupInfoId) => {
        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const languageMeta = store.getStore(['languageMeta']) || [];
        const groupItem = groupItems[groupInfoId] || {};

        // 找到对应的多语
        const currentIndex = languageMeta.find(e => e.languageCode === localeLang)?.index || '';
        const name = 'name' + (currentIndex == '1' ? '' : currentIndex);
        groupItem[name] = value;

        store.setStore(['cache', code, 'groupItems'], groupItems, true);
    }

    // 上移信息组
    moveToPrev = (currentItem = {}, index) => {
        const { attrcode, groupInfoId, groupFirstItem } = currentItem;

        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const data = store.getStore(['cache', code, 'view', 'data']) || [];

        const currentGroup = groupItems[groupInfoId];

        if (currentGroup) {

            const currentGroupLen = currentGroup?.items?.length;
            const prevIndex = index - 1;
            const prevItem = data[prevIndex];

            if (!prevItem) {
                // 首项  无法移动  TODO
                return;
            }

            // 旧的关联项
            const { direction, itemcode } = currentGroup;

            const { attrcode: prevAttrCode, groupInfoId: prevGroupInfoId } = prevItem;
            // 前面是个信息组  插入到前面一个信息组前
            if (prevGroupInfoId) {
                const { items: prevGroupItemCodes, itemcode, direction } = groupItems[prevGroupInfoId] || {};
                const prevGroupLen = prevGroupItemCodes.length;
                if (!prevGroupLen) {
                    console.log('未找到前一个信息组');
                }
                // 取出要移动的项 当前组
                const currentGroupItems = data.splice(index, currentGroupLen);

                // 移动到另外一个关联项上
                if (prevGroupInfoId !== groupInfoId) {
                    currentGroup.direction = direction;
                    currentGroup.itemcode = itemcode;
                    currentGroupItems.forEach(item => {
                        item.groupRelationCode = itemcode;
                    });
                }

                const finalIndex = index - prevGroupLen;
                data.splice(finalIndex, 0, ...currentGroupItems);
            } else {
                // 前面不是信息组
                // 当前信息组移动到前面一个字段
                currentGroup.itemcode = prevAttrCode;
                // currentGroup.position = 0;
                if (direction == 'after') {
                    currentGroup.direction = 'before';
                }

                // 修改数据
                for (let i = 0; i < currentGroupLen; i++) {
                    data[index + i].groupRelationCode = prevAttrCode;
                }

                // 调整数据位置
                const finalIndex = prevIndex + currentGroupLen;
                data.splice(prevIndex, 1);
                data.splice(finalIndex, 0, prevItem);
            }
            store.setStore(['cache', code, 'view', 'data'], data, false);
            store.setStore(['cache', code, 'groupItems'], groupItems);
        } else {
            // console.warn('操作异常');
        }
    }

    // 下移信息组
    moveToNext = (currentItem = {}, index) => {
        const { attrcode, groupInfoId, groupFirstItem } = currentItem;

        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const data = store.getStore(['cache', code, 'view', 'data']) || [];

        const currentGroup = groupItems[groupInfoId];

        if (currentGroup) {
            const currentGroupLen = currentGroup?.items?.length;
            const nextIndex = index + currentGroupLen;
            const nextItem = data[nextIndex];

            if (!nextItem) {
                // 首项  无法移动  TODO
                return;
            }

            // 旧的关联项
            const { direction, itemcode } = currentGroup;

            const { attrcode: nextAttrCode, groupInfoId: nextGroupInfoId } = nextItem;

            // 前面是个信息组  插入到前面一个信息组前
            if (nextGroupInfoId) {
                const { items: nextGroupItemCodes, itemcode, direction } = groupItems[nextGroupInfoId] || {};
                const nextGroupLen = nextGroupItemCodes.length;
                if (!nextGroupLen) {
                    console.log('未找到前一个信息组');
                }

                // 取出要移动的项 当前组
                const currentGroupItems = data.splice(index, currentGroupLen);

                // 移动到另外一个关联项上
                if (nextGroupInfoId !== groupInfoId) {
                    currentGroup.direction = direction;
                    currentGroup.itemcode = itemcode;
                    currentGroupItems.forEach(item => {
                        item.groupRelationCode = itemcode;
                    });
                }

                const finalIndex = index + nextGroupLen;
                data.splice(finalIndex, 0, ...currentGroupItems);
            } else {
                // 前面不是信息组
                // 当前信息组移动到前面一个字段
                currentGroup.itemcode = nextAttrCode;
                // currentGroup.position = 0;

                if (direction == 'before') {
                    currentGroup.direction = 'after';
                }
                // 修改数据
                for (let i = 0; i < currentGroupLen; i++) {
                    data[index + i].groupRelationCode = nextAttrCode;
                }
                // 调整数据位置
                const finalIndex = nextIndex - currentGroupLen;
                data.splice(nextIndex, 1);
                data.splice(finalIndex, 0, nextItem);
            }
            store.setStore(['cache', code, 'view', 'data'], data, false);
            store.setStore(['cache', code, 'groupItems'], groupItems);
        } else {
            // console.warn('操作异常');
        }
    }

    // 移除信息组
    remove = (currentItem = {}, index) => {
        const { attrcode, groupInfoId, groupFirstItem } = currentItem;

        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const viewData = store.getStore(['cache', code, 'view', 'data']) || [];
        let fieldData = store.getStore(['cache', code, 'field', 'data']) || [];

        const currentGroup = groupItems[groupInfoId];

        if (currentGroup) {

            // 旧的关联项
            const { direction, itemcode, items } = currentGroup;

            const currentGroupLen = items?.length;

            // 右边移除信息组
            const currentGroupItems = viewData.splice(index, currentGroupLen);

            // 如果有用已有的，没有左侧建立一个虚拟元素,
            let virtuallyItem = fieldData.find(item => item.attrcode === itemcode);
            if (!virtuallyItem) {
                virtuallyItem = viewData.find(item => item.attrcode === itemcode);
                virtuallyItem = { ...virtuallyItem, virtually: true, visible: false };
                fieldData.push(virtuallyItem);
            }

            // 左边添加信息组 关联到虚拟元素上
            currentGroup.visible = false;
            let spliceIndex = -1;
            fieldData.find((item, index) => {
                if (item.attrcode === itemcode) {
                    spliceIndex = index;
                }
            });
            if (spliceIndex !== -1) {
                spliceIndex = currentGroup.direction === 'before' ? spliceIndex : spliceIndex + 1;
                fieldData.splice(spliceIndex, 0, ...currentGroupItems);
            }

            store.setStore(['cache', code, 'view', 'data'], viewData, false);
            store.setStore(['cache', code, 'field', 'data'], fieldData, false);
            store.setStore(['cache', code, 'groupItems'], groupItems);
        } else {
            // console.warn('操作异常');
        }
    }

    getList = (DragItem, list, moveItem) => {
        const { store, code } = this.props;
        const groupItems = store.getStore(['cache', code, 'groupItems']) || {};
        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        // 用于计数
        let count = 0;

        return list.map((item, index) => {
            const { attrcode, groupInfoId, groupFirstItem } = item;

            // 开始分组渲染
            if (groupInfoId && groupFirstItem) {
                const { items: itemCodes, name, icontype, wordwrap, langname = '' } = groupItems[groupInfoId] || {};
                count = count === 0 ? 1 : 0;

                if (wordwrap) {
                    count = 1;
                }

                // 如果有必填的项，则不能删除
                let hasRequired = false;

                const itemNodes = itemCodes.map((attrcode, groupIndex) => {
                    const itemIndex = index + groupIndex;
                    const targetItem = list[itemIndex] || {};
                    const isnextrow = targetItem.isnextrow || targetItem.column == "5";

                    if (targetItem.required) {
                        hasRequired = true;
                    }

                    const itemNode = <DragItem
                        key={attrcode}
                        id={attrcode}
                        index={itemIndex}
                        draggable={false}
                        droppable={false}
                        moveItem={moveItem}
                        className={`${isnextrow ? 'group-item-wordwrap' : ''}`}
                    > <ListItem key={attrcode} areaCode={code} store={store} {...targetItem} isFixed={true} /> </DragItem>;
                    return itemNode;
                });

                const groupDom = <div key={`${attrcode}_content`} className={`view-info-group-wrapper count-${count}`}>
                    <div className="view-info-group-title">
                        {icontype &&
                            <div className="view-info-group-icon-wrapper">
                                <div className={`view-info-group-icon`}> <img src={icontype} alt="图" /></div>
                            </div>
                        }
                        <span className="view-info-group-label">{langJson['info-group-label'] || '分组名称'}</span>
                        <Input value={langname || name} onChange={value => {
                            this.onGroupTitleChange(value, groupInfoId);
                        }} placeholder={langJson['info-group-input-placeholder'] || '自定义标题'} />

                        <div className="view-info-group-action" >
                            {!hasRequired && !uncontrolledVisible && <div className="view-info-group-action-icon" onClick={this.remove.bind(this, item, index)}>
                                <Tooltip
                                    placement="top"
                                    overlay={langJson['action-icon-delete'] || '删除'}
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i
                                        className={getIconClass('shenpibohui', 'moveToRight')}
                                    />
                                </Tooltip>
                            </div>}
                            <div className="view-info-group-action-icon" onClick={this.moveToPrev.bind(this, item, index)}>

                                <Tooltip
                                    placement="top"
                                    overlay={langJson['action-icon-up'] || '上移'}
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i
                                        className={getIconClass('celashouqi', 'move-to-prev')}
                                    />
                                </Tooltip>
                            </div>

                            <div className="view-info-group-action-icon" onClick={this.moveToNext.bind(this, item, index)}>

                                <Tooltip
                                    placement="top"
                                    overlay={langJson['action-icon-down'] || '下移'}
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i
                                        className={getIconClass('fanhuishangyiji', 'move-to-next')}
                                    />
                                </Tooltip>
                            </div>

                        </div>
                    </div>
                    <div className="view-info-group-right">
                        {itemNodes}
                    </div>
                </div>;

                return wordwrap ? [<div key={1} className="view-info-group-space"></div>, groupDom] : [groupDom];
            }

            // 跳过中间项
            if (groupInfoId && !groupFirstItem) {
                return null;
            }

            const { groupInfoId: prevGroupInfoId, groupRelationCode: prevGroupRelationCode } = list[index - 1] || {};
            const { groupInfoId: nextGroupInfoId, groupRelationCode: nextGroupRelationCode } = list[index + 1] || {};

            const itemNode = <DragItem
                key={attrcode}
                id={attrcode}
                index={index}
                draggable={true}
                droppable={prevGroupRelationCode !== attrcode && nextGroupRelationCode !== attrcode}
                moveItem={moveItem}
                onStop={this.onStop}
            > <ListItem key={attrcode} areaCode={code} store={store} {...item} /> </DragItem>;

            // 开始计数
            if (nextGroupInfoId || prevGroupInfoId) {
                count = 0;
            }

            return [prevGroupInfoId ? <div className="view-info-group-space"></div> : null, itemNode, nextGroupInfoId ? <div className="view-info-group-space"></div> : null];
        });
    }

    render() {

        const { store, code } = this.props;
        const langJson = store.getStore('langJson');
        const viewStore = store.getStore(['cache', code, 'view']) || {};
        const { value, data = [] } = viewStore;

        return <div
        className="view-wrapper"
        fieldid={getSysFieldid('right_area')}
    >
            <div className="view-search">
                <span className="view-search-label">{langJson['view-list-title'] || '已添加'}</span>
                <Input
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                    className="view-search-input"
                />
            </div>
            <div className="view-list">
                <Dnd
                    data={data}
                    onDragEnd={this.onDragEnd}
                    getList={this.getList}
                    onStop={this.onStop}
                />
            </div>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 右侧点击删除 不删除数据，改变数据的
    onTransferToSource = e => {
        const { store, areaCode, attrcode } = this.props;
        let nextFieldSourceItem = [];
        const groupItems = store.getStore(['cache', areaCode, 'groupItems']) || {};

        {
            // 右边移除一个
            const viewStore = store.getStore(['cache', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;

            // 检查右边还有没有关联字段的信息组，有的话需要将信息组一并移动
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode, groupInfoId, groupRelationCode } = item;

                // 关联当前字段的信息组元素
                if (groupRelationCode === attrcode) {
                    const currentGroup = groupItems[groupInfoId];
                    currentGroup.visible = false;
                    nextFieldSourceItem.push(item);
                    return false;
                }

                if (currentCode === attrcode) {
                    // 显示
                    item.visible = false;
                    // item.ishighlight = false;
                    item.isbold = false;

                    nextFieldSourceItem.push(item);
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['cache', areaCode, 'view', 'data'], nextData, false);
        }
        {
            // 左边添加一个
            const fieldStore = store.getStore(['cache', areaCode, 'field']) || {};
            const { value, data = [] } = fieldStore;

            let nextData = data;

            // 检查左边还有没有关联字段的信息组  虚拟字段
            let spliceIndex = -1;
            data.find((item, index) => {
                if (item.attrcode === attrcode && item.virtually) {
                    spliceIndex = index;
                    return true;
                }
            });
            // 有虚拟项  移除虚拟项  添加真实项
            if (spliceIndex != -1) {
                nextData.splice(spliceIndex, 1, ...nextFieldSourceItem);
            } else {
                nextData = [...data, ...nextFieldSourceItem];
            }

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });
            store.setStore(['cache', areaCode, 'field', 'data'], nextData, true);
        }
    };

    // 取消高亮
    onToggleHighLight = ele => {
        const { store, areaCode, attrcode, ishighlight, isbold } = this.props;
        {
            // 更改状态
            const viewStore = store.getStore(['cache', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;

            const nextData = data.map(item => {
                const { label, attrcode: currentCode } = item;
                if (attrcode == currentCode) {
                    // item.ishighlight = !ishighlight;
                    item.isbold = !isbold;
                }

                item.filtered = match(label, value);

                return item;
            });

            store.setStore(['cache', areaCode, 'view', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            isFilter,
            label,
            required,
            noDeletion,
            redstar,
            highLight,
            ishighlight,
            isbold,
            filtered,
            isFixed,
            visible
        } = this.props;
        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        return <div className="view-item">
            <div
                className={classnames({
                    'view-item-filtered': filtered,
                    'view-item-content': true,
                    'show-highlight': isbold,
                })}
            >
                {required && <span className="unselected-mark iconfont icon-xinghao"></span>}
                <span className="view-label" title={label}>{label}</span>
                {
                    !isFixed && !required && !uncontrolledVisible && <span className="view-icon" onClick={this.onTransferToSource}>
                        <Tooltip
                            placement="top"
                            overlay={langJson['action-icon-delete']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={getIconClass('shenpibohui', 'moveToRight')}
                                style={(noDeletion || redstar) ? { color: '#aeaeae', cursor: 'not-allowed' } : {}}
                            />
                        </Tooltip>
                    </span>
                }

                {/* {!isFixed && <span className="view-icon icon-highlight" onClick={this.onToggleHighLight}>
                    <Tooltip
                        placement="top"
                        overlay={isbold ? langJson['action-icon-unlight'] : langJson['action-icon-light']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('gaoliang', isbold ? 'activated' : 'close')} />
                    </Tooltip>
                </span>} */}
            </div>
        </div>;
    }
}

export default View;